import React, { Component } from "react";
import { BrowserRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import Media from "react-media";

class Home extends Component {
  state = {};

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return <React.Fragment />;
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/home.jsx